import React from 'react';
import { Segment } from 'semantic-ui-react';
import _ from 'lodash';

var $ = require("jquery");

class NewCommonRichEditor extends React.Component {
    constructor(props) {
        super(props);
        const debounceTime = props.debounceTime || 500;
        this.currValue = props.value || null;
        this.editerFrame = null;
        let texEditorId = new Date().valueOf().toString() + '-texteditor';
        this.state = {
            isDivLoaded: false,
            texEditorId: texEditorId,
        };
        this.handleChange = _.debounce(this.handleChange, debounceTime);
    }

    messageListener = (event)=>{
        if(event && event.data){
            if(typeof event.data === 'string'){
                let data = JSON.parse(event.data);
                if(data.type === "ON_CHANGE"){
                    this.handleChange(data.value);
                    this.currValue = data.value;
                }else if(data.type === "ON_BLUR"){
                    if(this.props.onBlur && typeof this.props.onBlur === 'function'){
                        this.props.onBlur();
                    }
                }
            }
        }
    }

    setupIFrame = ()=>{
        const iframe = document.createElement("iframe");
        iframe.srcdoc = `<!DOCTYPE html>
        <html lang="en" style="font-size:9px">
          <head>
          <script src="https://code.jquery.com/jquery-3.4.1.slim.min.js" integrity="sha384-J6qa4849blE2+poT4WnyKhv5vZF5SrPo0iEjwBvKU7imGFAV0wwj1yYfoRSJoZ+n" crossorigin="anonymous"></script>
          <link href="https://cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote-lite.min.css" rel="stylesheet">
          <link href="/assets/css/vendorBundle.css" rel="stylesheet">
          <link href="/assets/css/semanticUI.css" rel="stylesheet">
          
          <script src="https://cdn.jsdelivr.net/npm/summernote@0.8.18/dist/summernote-lite.min.js"></script>
          <style>
            body {
                margin: 0
            }
          </style>
          </head>
          <body>
            <div id="page_content">
                <div id=${this.state.texEditorId}></div>
            </div>
          </body>
          <script>(function () {
            $(\`#${this.state.texEditorId}\`).summernote(
                {
                    height:400,
                    minHeight: 400,
                    maxHeight: 400,
                    toolbar: [
                        ['style', ['style']],
                        ['font', ['fontname','fontsize', 'bold', 'underline', 'clear']],
                        ['color', ['color']],
                        ['para', ['ul', 'ol', 'paragraph']],
                        ['table', ['table']],
                        ['insert', ['link', 'picture']],
                        ['view', ['codeview', 'help']],
                    ],
                    popover: {
                        image: [
                          ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                          ['float', ['floatLeft', 'floatRight', 'floatNone']],
                          ['remove', ['removeMedia']]
                        ],
                        link: [
                          ['link', ['linkDialogShow', 'unlink']]
                        ],
                        table: [
                          ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                          ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
                        ],
                      },
                    disableGrammar: true,
                    spellCheck: false,
                    callbacks: {
                        onChange: (content)=>{
                            let payload = {
                                type: "ON_CHANGE",
                                value: content,
                            };
                            window.parent.postMessage(JSON.stringify(payload), '*');
                        },
                        onBlur: ()=>{
                            let payload = {
                                type: "ON_BLUR",
                                value: "",
                            };
                            window.parent.postMessage(JSON.stringify(payload), '*');
                        },
                        onChangeCodeview: (content)=>{
                            let payload = {
                                type: "ON_CHANGE",
                                value: content,
                            };
                            window.parent.postMessage(JSON.stringify(payload), '*');
                        }
                    }
                }
            );
            window.addEventListener('message', (event)=>{
                if(typeof event.data === 'string'){
                    let data = JSON.parse(event.data);
                    if(data.type === 'RESET'){
                        $(\`#${this.state.texEditorId}\`).summernote('reset');
                    }else if(data.type === 'CODE'){
                        $(\`#${this.state.texEditorId}\`).summernote('code', data.value);
                    }
                }
            });
        })()</script>
        </html>`;
        iframe.sandbox = "allow-scripts";
        iframe.style.width = "100%";
        iframe.style.minHeight = '500px';
        iframe.style.zIndex = 10;
        let parentNode = document.getElementById(`${this.state.texEditorId + "-container"}`);
        if(parentNode != null){
            parentNode.appendChild(iframe);
            this.editerFrame = iframe;
        };
        // using event listener to handle the 
        window.addEventListener('message', this.messageListener);
        
        if(this.props.value){
            let HTMLstring = this.props.value;
            if(this.editerFrame != null){
                setTimeout(()=>{
                    let payloadA = {
                        type: "CODE",
                        value: HTMLstring,
                    };   
                    this.editerFrame.contentWindow.postMessage(JSON.stringify(payloadA),"*");
                    $(`#${this.state.texEditorId}`).summernote('code', HTMLstring);
                },200);    
            }
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({
                isDivLoaded: true,
            });
            this.setupIFrame();
        }, 500);
    }

    

    componentDidUpdate(prevProps){
        if(prevProps.value !== this.props.value && this.props.value !== this.currValue){
            if(this.editerFrame != null){
                let payloadA = {
                    type: "RESET",
                    value: "",
                };
                let payloadB = {
                    type: "CODE",
                    value:this.props.value,
                };
                this.editerFrame.contentWindow.postMessage(JSON.stringify(payloadA),"*");
                this.editerFrame.contentWindow.postMessage(JSON.stringify(payloadB),"*");
            }
        }
    }

    handleChange = (content)=>{
        //console.log(content);
        if(this.props.onChange && typeof this.props.onChange === 'function'){
            this.props.onChange(content);
        }
    }

    componentWillUnmount(){
        window.removeEventListener('message', this.messageListener);
    }

    initalSummerNote = ()=>{
        $(`#${this.state.texEditorId}`).summernote(
            {
                height:300,
                toolbar: [
                    ['style', ['style']],
                    ['font', ['bold', 'underline', 'clear']],
                    ['color', ['color']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['table', ['table']],
                    ['insert', ['link', 'picture']],
                    ['view', ['fullscreen', 'codeview', 'help']],
                ],
                popover: {
                    image: [
                      ['image', ['resizeFull', 'resizeHalf', 'resizeQuarter', 'resizeNone']],
                      ['float', ['floatLeft', 'floatRight', 'floatNone']],
                      ['remove', ['removeMedia']]
                    ],
                    link: [
                      ['link', ['linkDialogShow', 'unlink']]
                    ],
                    table: [
                      ['add', ['addRowDown', 'addRowUp', 'addColLeft', 'addColRight']],
                      ['delete', ['deleteRow', 'deleteCol', 'deleteTable']],
                    ],
                  },
                disableGrammar: true,
                callbacks: {
                    onChange: (content)=>{
                        this.handleChange(content);
                        this.currValue = content;
                    },
                    onBlur: ()=>{
                        if(this.props.onBlur && typeof this.props.onBlur === 'function'){
                            this.props.onBlur();
                        }
                    }
                }
            }
        );
        $('.dropdown-toggle').dropdown();
        $('div.note-editable').height(300);
        
        
    }

    render() {
        return (
            <>
                {
                    this.state.isDivLoaded && 
                    <div id={`${this.state.texEditorId + "-container"}`} style={{minHeight:'500px', width:'100%'}}></div>
                }
                {
                    !this.state.isDivLoaded && 
                    <Segment loading={true} style={{minHeight:'500px', width:'100%'}}></Segment>
                }
            </>
        );
    }
}

export default NewCommonRichEditor;